import React, { forwardRef, ReactNode } from 'react';
import styled from 'styled-components/macro';

interface IBadgeProps {
  children: ReactNode;
  fontColor?: string;
  backgroundColor?: string;
}

const Badge = forwardRef<HTMLDivElement, IBadgeProps>(({ children, backgroundColor, fontColor }, ref): JSX.Element => {
  return (
    <StyledBadge backgroundColor={backgroundColor} fontColor={fontColor} ref={ref}>
      {children}
    </StyledBadge>
  );
});

Badge.displayName = 'Badge';

const StyledBadge = styled.div<{
  backgroundColor?: string;
  fontColor?: string;
}>`
  display: inline-block;
  vertical-align: baseline;
  font-size: 12px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 5px;
  color: ${({ fontColor }): string => (fontColor ? fontColor : 'var(--chakra-colors-text-info)')};
  background-color: ${({ backgroundColor }): string =>
    backgroundColor ? backgroundColor : 'var(--chakra-colors-background-info)'};
  word-break: break-all;
`;

export default Badge;
